var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 0.666748C3.05602 0.666748 0.666687 3.05608 0.666687 6.00008C0.666687 8.94408 3.05602 11.3334 6.00002 11.3334C8.94402 11.3334 11.3334 8.94408 11.3334 6.00008C11.3334 3.05608 8.94402 0.666748 6.00002 0.666748ZM6.00002 10.2667C3.64269 10.2667 1.73335 8.35741 1.73335 6.00008C1.73335 3.64275 3.64269 1.73341 6.00002 1.73341C8.35735 1.73341 10.2667 3.64275 10.2667 6.00008C10.2667 8.35741 8.35735 10.2667 6.00002 10.2667Z",
    fill: "#737D86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleEmpty);
export default __webpack_public_path__ + "static/media/circle-empty.75be7fb02eac6dd56e75be5ae02d2848.svg";
export { ForwardRef as ReactComponent };